'use client';

import { createPage } from '@/app/_shared/utils/dynamicImports';

const Rising = createPage(
	() => import('@/features/discover/components/Rising'),
);

export default function RisingPage() {
	return <Rising />;
}
